import { httpPost, httpDownload } from '../../../../utils/api.utils';
import {
    setBillingAccountHistoryLogsLoading
    , getBillingAccountHistoryLogs
    , setBillingAccountHistoryPageSize
    , resetBillingAccountHistory
    , setBillingAccountColSearchStr,
} from '../../../../constants/model-reducers/external/finance/billing-account/billing-account-history.settings';
import { DEFAULT_TABLE_RESULT_MODEL } from '../../../../constants/external-constants';
import { getLocalTimeZone, convertToFormatTimeZoneDate } from '../../../../utils/helpers.utils';

const emptyHistoryTable = (pagination = DEFAULT_TABLE_RESULT_MODEL.Pagination, headers = {}) => ({
    ...DEFAULT_TABLE_RESULT_MODEL,
    Headers: Object.keys(headers).length ? headers : Object.fromEntries(
        [['Event', 'Event'], ['Object', 'Object'], ['OldValue', 'Old Value'],
            ['NewValue', 'New Value'], ['User', 'User'], ['Date', 'Date']]
            .map(([propName, name], order) => [propName, {
                propName, name, order, hidden: false, searchString: ''
            }])
    ),
    Data: { Items: [], PageIndex: 0 },
    Pagination: {
        ...DEFAULT_TABLE_RESULT_MODEL.Pagination,
        PerPage: pagination.PerPage,
        PageSizes: pagination.PageSizes
    }
});

const defaultState = () => ({
    HistoryTable: emptyHistoryTable(),
    IsLoadingTable: false
});
 
const initialState = defaultState();

export const billingAccountHistoryActions = {
    getBillingAccountHistoryLogs: (financeAccountId, pageIndex = 0) => async (dispatch, state) => {
        const { Pagination, Headers } = state().billingAccountHistory.HistoryTable;
        var formData = {
            FinanceAccountId: financeAccountId,
            PageIndex: pageIndex,
            PageSize: Pagination.PerPage,
            PageSizes: Pagination.PageSizes,
            Headers: Headers
        };

        dispatch({
            type: setBillingAccountHistoryLogsLoading,
            isLoadingTable: true
        });

        let historyTable = emptyHistoryTable(Pagination, Headers);
        try {
            const result = await httpPost('external/finance/getBillingAccountHistoryLogs', formData);
            if (result?.Headers && Array.isArray(result?.Data?.Items) && result?.Pagination) {
                historyTable = result;
            }
        } catch {
            // Keep the default empty table when the history request fails.
        }
       
        dispatch({
            type: getBillingAccountHistoryLogs,
            historyTable,
            isLoadingTable: false
        });
    },

    resizeBillingAccountHistoryLogs: (pageSize) => async (dispatch, state) => {
        dispatch({
            type: setBillingAccountHistoryPageSize,
            pageSize: parseInt(pageSize),
        });
    },
    setBillingAccountColSearchStr: (event, key) => async (dispatch, state) => {
        var val = event.target.value;
        const { HistoryTable } = state().billingAccountHistory;
        var historyTableHeaderUpd = {
            ...HistoryTable,
            "Headers": {
                ...HistoryTable.Headers,
                [key]: {

                    ...HistoryTable.Headers[key],
                    searchString: val
                }
            }
        }

        dispatch({
            type: setBillingAccountColSearchStr,
            historyTable: historyTableHeaderUpd
        });
    },
    resetBillingAccountHistory: () => (dispatch, state) => {
        dispatch({
            type: resetBillingAccountHistory
        })
    },
    
    extractBillingAccountHistoryLogs: (financeAccountID) => async (dispatch, state) => {
        const { Headers } = state().billingAccountHistory.HistoryTable;
        const dealName = sessionStorage.getItem('DealName');
        const { activeDateFormat, activeTimeZoneOffset } = state().adminSetting;

        const formattedTimeZoneDate = convertToFormatTimeZoneDate(
            new Date(),
            activeDateFormat?.Name || "YYYY-MM-DD",
            activeTimeZoneOffset?.UtcOffset || 0)
            .replace(/[<>:"/\|?*]/g, '-');
        const filename = `ATEM ${dealName} Billing Account History – ${formattedTimeZoneDate}`;

        var formData = {
            FinanceAccountID: financeAccountID,
            Headers: Headers,
            FileName: filename,
            TimeZone: getLocalTimeZone()
        };
        httpDownload('external/finance/getExtractBillingAccountHistoryLogs', formData)
            .then(function (response) {
                return response.blob();
            })
            .then(function (blob) {
                let downloadUrl = window.URL.createObjectURL(blob);
                //Hide Loading
                let a = document.createElement('a');
                if (window.navigator.msSaveOrOpenBlob) {
                    window.navigator.msSaveOrOpenBlob(blob, filename);
                } else if (typeof a.download === 'undefined') {
                    window.location = downloadUrl;
                } else {
                    a.href = downloadUrl;
                    a.download = filename + '.xlsx';
                    document.body.appendChild(a);
                    a.click();
                }
            });
    },
}

export const reducer = (state, action) => {
    state = state || initialState;

    switch (action.type) {
        case setBillingAccountHistoryLogsLoading:
            return {
                ...state,
                IsLoadingTable: action.isLoadingTable
            }
        case getBillingAccountHistoryLogs:
            return {
                ...state,
                HistoryTable: action.historyTable,
                IsLoadingTable: action.isLoadingTable
            }
        case setBillingAccountHistoryPageSize:
            return {
                ...state,
                HistoryTable: {
                    ...state.HistoryTable,
                    Pagination: {
                        ...state.HistoryTable.Pagination,
                        PerPage: action.pageSize
                    }
                }
            }
        case setBillingAccountColSearchStr:
            return {
                ...state,
                HistoryTable: action.historyTable,
            }
        case resetBillingAccountHistory:
            return initialState;
        default:
            return state;
    }
}
